const fakeExpense = [
  {
    _id: "689fae0015e3012f93caa011",
    branch: {
      addressInfo: {
        coordinates: {
          latitude: -17.790001,
          longitude: -63.210123,
        },
        street: "Av. San Martín, Santa Cruz de la Sierra, Bolivia",
      },
      _id: "649b1111dab0173b9b7f0cde",
      name: "Sucursal San Martín",
    },
    type: "Egreso",
    employee: {
      _id: "65fb1234e8247b801aa11aa11",
      fullName: "Carlos Pinto",
      phone: "78945612",
      photoURL: "https://te-ayudo-img.s3.us-east-2.amazonaws.com/test/users/carlos-pinto-photo.png",
      CI: "6543210",
      location: [],
    },
    description: "Compra de insumos de limpieza",
    amount: 90,
    provider: "5e6b31a018048974ea17f435",
    date: "2025-06-05T08:10:00.000Z",
    createdAt: "2025-06-05T08:10:00.000Z",
    updatedAt: "2025-06-05T08:10:00.000Z",
    __v: 0,
    id: "689fae0015e3012f93caa011",
  },
  {
    _id: "689fae1215e3012f93caa012",
    branch: {
      addressInfo: {
        coordinates: {
          latitude: -17.765432,
          longitude: -63.200987,
        },
        street: "Calle 24 de Septiembre, Santa Cruz de la Sierra, Bolivia",
      },
      _id: "649c2222dab0173b9b7a0ddd",
      name: "Sucursal Central",
    },
    type: "Egreso",
    employee: {
      location: [],
    },
    description: "Pago de servicios básicos",
    amount: 300,
    provider: "5e6b31a018048974ea17f435",
    date: "2025-06-04T15:30:00.000Z",
    createdAt: "2025-06-04T15:30:00.000Z",
    updatedAt: "2025-06-04T15:30:00.000Z",
    __v: 0,
    id: "689fae1215e3012f93caa012",
  },
  {
    _id: "689fae1c15e3012f93caa013",
    branch: {
      addressInfo: {
        coordinates: {
          latitude: -17.802222,
          longitude: -63.215123,
        },
        street: "Av. Alemana, Santa Cruz de la Sierra, Bolivia",
      },
      _id: "649c3333dab0173b9b7a0eee",
      name: "Sucursal Alemana",
    },
    type: "Egreso",
    employee: {
      _id: "65fb1234e8247b801aa22bb22",
      fullName: "Laura Méndez",
      phone: "70000001",
      photoURL: "https://te-ayudo-img.s3.us-east-2.amazonaws.com/test/users/laura-mendez-photo.png",
      CI: "1122334",
      location: [],
    },
    description: "Reembolso de viáticos",
    amount: 45,
    provider: "5e6b31a018048974ea17f435",
    date: "2025-06-03T10:45:00.000Z",
    createdAt: "2025-06-03T10:45:00.000Z",
    updatedAt: "2025-06-03T10:45:00.000Z",
    __v: 0,
    id: "689fae1c15e3012f93caa013",
  },
  {
    _id: "689fae2815e3012f93caa014",
    branch: {
      addressInfo: {
        coordinates: {
          latitude: -17.790678,
          longitude: -63.189999,
        },
        street: "Calle Libertad y 2do anillo, Santa Cruz de la Sierra, Bolivia",
      },
      _id: "649c4444dab0173b9b7a0fff",
      name: "Sucursal Libertad",
    },
    type: "Egreso",
    employee: {
      location: [],
    },
    description: "Compra de mobiliario",
    amount: 480,
    provider: "5e6b31a018048974ea17f435",
    date: "2025-06-02T14:20:00.000Z",
    createdAt: "2025-06-02T14:20:00.000Z",
    updatedAt: "2025-06-02T14:20:00.000Z",
    __v: 0,
    id: "689fae2815e3012f93caa014",
  },
];
export default fakeExpense;
